import React from "react";
import img from "../../assets/img/teeth.png";
import finance from "../../assets/img/finance.png";
import smile from "../../assets/img/smile.png";

const Services = () => {
  return (
    <div className="container-fluid bg-white py-5">
      <div className="px-5 pt-5 align-items-center">
        <div className="row">
          <div className="col-md-4 d-flex flex-column align-items-center my-3 px-lg-5">
            <img
              src={img}
              className="rounded-4"
              height="90"
              alt="Dental Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">No Downtime</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              We simply apply composite resin to your teeth so there’s no
              downtime and you can get on with your day as normal
            </p>
          </div>

          <div className="col-md-4 d-flex flex-column align-items-center border-md-left my-3 px-lg-5">
            <img
              src={smile}
              className="rounded-4"
              height="90"
              alt="Smile Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">Smile Design</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              Every smile is bespoke and designed with you to suit you. You even
              have the option of test driving your smile before committing
            </p>
          </div>

          <div className="col-md-4 d-flex flex-column align-items-center border-md-left my-3 px-lg-5">
            <img
              src={finance}
              className="rounded-4"
              height="90"
              alt="Finance Icon"
            />
            <h3 className="text-dark fs-18 fw-800 pt-2">Flexible Payments</h3>
            <p className="text-dark fs-17 fw-400 text-center lh-lg">
              A wide range of payment options, including 0% over 12 months to
              make your smile more affordable than ever
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
